import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    Input,
    OnDestroy,
    OnInit,
    ViewRef
} from '@angular/core';
import { TextBox } from '../../../../../models/text-box';
import { ApplicationStateService } from '../../../../../services/application-state.service';
import { SelectionPageEditMode } from '../../../../../utils/page-edit-modes/selection-page-edit-mode';
import { CommunicationService } from '../../../../../services/communication.service';
import { ZoomService } from '../../../../../services/zoom.service';
import { Subscription } from 'rxjs';
import _ from 'lodash';
import { NgStyle } from '@angular/common';

@Component({
    selector: 'app-page-text-boxes',
    templateUrl: './page-text-boxes.component.html',
    styleUrls: ['./page-text-boxes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgStyle
    ]
})
export class PageTextBoxesComponent implements OnInit, OnDestroy {

    @Input() active: boolean;
    textBoxes: Array<TextBox> = [];

    subscription: Subscription;

    private readonly debouncedTriggerChangeDetection: (() => void) & _.Cancelable;

    constructor(public applicationStateService: ApplicationStateService,
                private changeDetectorRef: ChangeDetectorRef,
                public zoomService: ZoomService,
                private communicationService: CommunicationService) {

        // Prevents to run change detection too often.
        this.debouncedTriggerChangeDetection = _.debounce(this.triggerChangeDetection, 100);

        this.communicationService.detectChangesAnnounced$.subscribe(() => {
            this.debouncedTriggerChangeDetection();

        });
    }

    ngOnInit(): void {
        // Disable change detection because of too many DOM elements (big performance boost)
        this.changeDetectorRef.detach();
    }

    ngOnDestroy(): void {
        // Subscription might not be initialized.
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }

    /**
     * Refresh the component.
     */
    setTextBoxes(textBoxes: Array<TextBox>): void {
        this.textBoxes = textBoxes;
    }

    triggerChangeDetection(): void {
        if (!(this.changeDetectorRef as ViewRef).destroyed) {
            this.changeDetectorRef.detectChanges();
        }
    }

    onMouseOver(): void {
        if (this.applicationStateService.pageEditMode && this.applicationStateService.pageEditMode instanceof SelectionPageEditMode) {
            this.triggerChangeDetection();
        }
    }

    onTouchMove(): void {
        if (this.applicationStateService.pageEditMode && this.applicationStateService.pageEditMode instanceof SelectionPageEditMode) {
            this.triggerChangeDetection();
        }
    }

    trackByFn(index, item): void {
        return index; // or item.id
    }
}
